export default "__VITE_ASSET__0FFNRyMf__"